'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetBlank = function TargetBlank(props) {
  return _react2.default.createElement(
    'a',
    _extends({ rel: 'noopener noreferrer', target: '_blank' }, props),
    props.children
  );
};

TargetBlank.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node.isRequired
} : {};

exports.default = TargetBlank;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/TargetBlank/index.js
// module id = 482
// module chunks = 14